import { render } from "./Qoutes.vue?vue&type=template&id=50600f18&scoped=true"
import script from "./Qoutes.vue?vue&type=script&lang=js"
export * from "./Qoutes.vue?vue&type=script&lang=js"

import "./Qoutes.vue?vue&type=style&index=0&id=50600f18&lang=scss&scoped=true"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50600f18"]])

export default __exports__